type WinningMomentsPrizeTimeline = {
    startDate: number | string | null | undefined,
    endDate: number | string | null | undefined
};

const getPrizeTimelineKey = (prize: WinningMomentsPrizeTimeline) => JSON.stringify([String(prize.startDate), String(prize.endDate)]);

const isAdvancedWinningMomentsGeneration = (prizes: WinningMomentsPrizeTimeline[]) => {
    const timelineKeys = new Set(prizes.map(getPrizeTimelineKey));

    return timelineKeys.size > 1 || prizes.length === 1;
};

export { isAdvancedWinningMomentsGeneration };
